<template>
<div class="chapter">
<div class="inner_page">
<h1>Contents</h1>
<p class="toc1" style="margin-top:60px;"><a href="#/section6">A Note on Timing</a></p>
<p class="toc1"><a href="#/section7">Prologue</a></p>
<p class="toc1"><a href="#/section8">ONE: Blow, bugle!</a></p>
<p class="toc1"><a href="#/section9">TWO: Youth comes back</a></p>
<p class="toc1"><span href="#/section10" title="Link target outside of Sample">THREE: Voices prophesying</span></p>
<p class="toc1"><span href="#/section11" title="Link target outside of Sample">FOUR: Destiny obscure</span></p>
<p class="toc1"><span href="#/section12" title="Link target outside of Sample">FIVE: Hostages to fortune</span></p>
<p class="toc1"><span href="#/section13" title="Link target outside of Sample">Interlude</span></p>
<p class="toc1"><span href="#/section14" title="Link target outside of Sample">SIX: Strange intelligence</span></p>
<p class="toc1"><span href="#/section15" title="Link target outside of Sample">SEVEN: Currents turn awry</span></p>
<p class="toc1"><span href="#/section16" title="Link target outside of Sample">EIGHT: Gather ye rosebuds</span></p>
<p class="toc1"><span href="#/section17" title="Link target outside of Sample">NINE: Unhallowed ground</span></p>
<p class="toc1"><span href="#/section18" title="Link target outside of Sample">TEN: Wild bells</span></p>
<p class="toc1"><span href="#/section19" title="Link target outside of Sample">ELEVEN: Strait the gate</span></p>
<p class="toc1"><span href="#/preview" title="Link target outside of Sample">PREVIEW: Upland Outlaws</span></p>
<p class="toc1"><span href="#/section26" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?41136fa9